// extracted by mini-css-extract-plugin
export default {"row":"TuFhC3rh"};